<template>
  <header
    class="base-type-shell__cap"
    :class="{ 'base-type-shell__cap--neutral': neutral }"
  >
    <router-link
      v-if="showBackLink && resolvedBackRouteName"
      :to="{ name: resolvedBackRouteName }"
      class="base-type-shell__back"
    >
      <Icon icon="fa-pro-solid:arrow-left" />
      {{ resolvedBackLabel }}
    </router-link>

    <div class="base-type-shell__record-row">
      <div class="base-type-shell__record-main">
        <div
          class="base-type-shell__record-icon"
          :class="{ 'base-type-shell__record-icon--neutral': neutral }"
          aria-hidden="true"
        >
          <Icon :icon="resolvedIcon" />
        </div>
        <h1 class="base-type-shell__record-name">
          <slot name="title">{{ title }}</slot>
          <ObjectNeedsReviewIcon v-if="inReview" :label="reviewLabel" />
        </h1>
      </div>
      <span v-if="subtitle" class="base-type-shell__record-mode">{{ subtitle }}</span>
    </div>

    <div v-if="$slots['header-actions']" class="base-type-shell__header-actions">
      <slot name="header-actions" />
    </div>
  </header>
</template>

<script>
import ObjectNeedsReviewIcon from '@/components/objects/ObjectNeedsReviewIcon.vue'
import {OBJECT_REVIEW_LABEL} from '@/utils/objectReview'
import {getBaseTypeTheme} from "@/utils/baseTypeTheme";

export default {
  name: 'BaseTypePageCap',
  components: {
    ObjectNeedsReviewIcon,
  },
  props: {
    baseType: {
      type: String,
      default: null,
      validator: (value) => !value || ['accommodations', 'offers', 'events', 'discover'].includes(value),
    },
    icon: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: null,
    },
    showBackLink: {
      type: Boolean,
      default: false,
    },
    backRouteName: {
      type: String,
      default: null,
    },
    backLabel: {
      type: String,
      default: null,
    },
    neutral: {
      type: Boolean,
      default: false,
    },
    inReview: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    reviewLabel() {
      return OBJECT_REVIEW_LABEL
    },
    resolvedIcon() {
      if (this.icon) {
        return this.icon
      }

      if (this.baseType) {
        return getBaseTypeTheme(this.baseType).icon
      }

      return 'fa-pro-solid:circle'
    },
    resolvedBackLabel() {
      if (this.backLabel) {
        return this.backLabel
      }

      if (this.baseType) {
        return getBaseTypeTheme(this.baseType).label
      }

      return ''
    },
    resolvedBackRouteName() {
      if (this.backRouteName) {
        return this.backRouteName
      }

      if (this.baseType) {
        return `${this.baseType}.index`
      }

      return null
    },
  },
}
</script>
